import Accordion from '../libaries/accordian';
import MenuButton from '../libaries/menu-button';
import Utilities from '../utilities/utilities';

// let $navDesktop;
let $navMobile;
const accordions = [];
let $accordions;
let $accordionLang;
let $searchForm;
let $searchInput;
let $searchLabel;
let $langSelect;
let $navItemsWithDropdown;
let overlays = {};
let navHeightMobile = 0;
const navMenus = [];
let langMenu;
// let trap;

// function setupTrap() {
//   const headersMobile = document.querySelector('.js-headers--mobile');
//   trap = focusTrap.createFocusTrap(headersMobile);
// }

function handleResize() {
  $navItemsWithDropdown.forEach((item) => {
    const $dropdown = item.querySelector('.js-dropdown');
    if (Utilities.offscreen($dropdown, item.getBoundingClientRect().left, 'right')) {
      $dropdown.classList.add('right-aligned');
    } else {
      $dropdown.classList.remove('right-aligned');
    }
  });
}

function closeOverlay(type) {
  Utilities.disableScroll(true);

  const overlay = overlays[type];
  overlay.initiator.setAttribute('aria-expanded', false);
  overlay.initiator.classList.remove('is-active');
  overlay.initiator.focus();
  overlay.overlay.classList.remove('is-active');
  overlay.active = false;

  // trap.deactivate();
}

function openOverlay(type) {
  if (type === 'nav') closeOverlay('search');
  else closeOverlay('nav');

  Utilities.disableScroll(false);

  const overlay = overlays[type];
  overlay.initiator.setAttribute('aria-expanded', true);
  overlay.initiator.classList.add('is-active');
  overlay.overlay.classList.add('is-active');
  overlay.focusOn.focus();
  overlay.active = true;

  overlay.overlay.addEventListener('click', (e) => {
    if (!overlay.content.contains(e.target)) {
      closeOverlay(type);
    }
  });

  // trap.activate();
}

function toggleOverlay(type) {
  if (overlays[type].active) {
    closeOverlay(type);
  } else {
    openOverlay(type);
  }
}

function handleOverlayToggle(e, type) {
  e.preventDefault();
  toggleOverlay(type);
}

function initoverlays() {
  overlays = {
    nav: {
      initiator: document.querySelector('.js-mobile-initiator--nav'),
      overlay: document.querySelector('.js-overlay--nav'),
      content: document.querySelector('.js-overlay-content--nav'),
      focusOn: document.querySelector('button.js-focausable--nav'),
      active: false,
    },
    search: {
      initiator: document.querySelector('.js-mobile-initiator--search'),
      overlay: document.querySelector('.js-overlay--search'),
      content: document.querySelector('.js-overlay-content--search'),
      focusOn: document.querySelector('.js-focausable--search'),
      active: false,
    },
  };

  overlays.nav.initiator.addEventListener('click', (e) => handleOverlayToggle(e, 'nav'));
  overlays.search.initiator.addEventListener('click', (e) => handleOverlayToggle(e, 'search'));
}

function searchLabelToggle(e) {
  if (e.type === 'focusin') {
    $searchLabel.classList.add('visuallyhidden');
  } else {
    $searchLabel.classList.remove('visuallyhidden');
  }
}

function searchFocus() {
  $searchInput.focus();
}

function scrollToOverlay() {
  const scrollTopVal = $accordionLang.getBoundingClientRect().top + window.pageYOffset - navHeightMobile;
  overlays.nav.overlay.scrollTo({ top: scrollTopVal, behavior: 'smooth' });
}

function init() {
  // $navDesktop = document.querySelector('.js-header');
  $navMobile = document.querySelector('.js-header--mobile');
  $accordions = document.querySelectorAll('.js-accordion');
  $accordionLang = document.querySelector('.js-accordion--lang');
  $searchForm = document.querySelector('.js-search-form');
  $searchInput = document.querySelector('.js-search-input');
  $searchLabel = document.querySelector('.js-search-label');
  $langSelect = document.querySelector('.js-lang-select');
  $navItemsWithDropdown = document.querySelectorAll('.js-nav__item--dropdown');

  navHeightMobile = $navMobile ? $navMobile.offsetHeight : 0;

  window.addEventListener('resize', handleResize);
  handleResize();

  // TODO: fix this.
  $accordions.forEach((accordion) => {
    // Assuming `accordion` is a custom function; replace as needed
    accordions.push(new Accordion(accordion));
  });

  initoverlays();

  // code for mobile Menu Language button, it's on the div instead of the button.
  const $accordionLangButton = $accordionLang.querySelector('button');
  if ($accordionLangButton) {
    $accordionLangButton.addEventListener('click', scrollToOverlay);
  } else {
    console.log('No button found in accordionLang');
  }

  $searchForm.addEventListener('click', searchFocus);
  $searchInput.addEventListener('focusin', searchLabelToggle);
  $searchInput.addEventListener('focusout', searchLabelToggle);

  if ($langSelect && $navItemsWithDropdown.length > 0) {
    langMenu = new MenuButton($langSelect.querySelector('.js-menu__button'));

    $navItemsWithDropdown.forEach((item, index) => {
      navMenus[index] = new MenuButton(item.querySelector('.js-menu__button'));
    });
  }

  // setupTrap();
}

function destroy() {
  window.removeEventListener('resize', handleResize);

  if (langMenu) {
    langMenu.destroy();
  }
  navMenus.forEach((menu) => {
    menu.destroy();
  });
}

export default {
  init() {
    init();
  },
  close() {
    closeOverlay('nav');
    closeOverlay('search');
  },
  // not used
  unload() {
    destroy();
  },
};
